import { render, staticRenderFns } from "./TabExplainer.vue?vue&type=template&id=1f71102c&scoped=true"
import script from "./TabExplainer.vue?vue&type=script&lang=ts"
export * from "./TabExplainer.vue?vue&type=script&lang=ts"
import style0 from "./TabExplainer.vue?vue&type=style&index=0&id=1f71102c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f71102c",
  null
  
)

export default component.exports